// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__ppG4I","title":"ClientReferral_title__2NXSj","itemText":"ClientReferral_itemText__3_cHO"};